import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { setupI18n } from './i18n'
import './assets/main.scss'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
// Setup i18n after pinia to ensure store is accessible
const i18n = setupI18n()
app.use(i18n)
app.use(router)

app.mount('#app')